import React, {useCallback, useEffect, useState} from 'react';
import {getUser} from '../../Profile/redux/profile.action';
import {getGamificationDetails} from '../../rewards/redux/rewards.action';
import {getCurrentRoute} from '../../../navigation/rootNavigation';
import {globalStyle} from '../../../assets';
import CommonModal from '../../../commonComponents/commonModal';
import {View, Text} from 'react-native';
import BuySell from '../../event/childComponents/BuySell';
import {trackMoengageEvent} from '../../../utils/commonMethods';
import {connect, useDispatch} from 'react-redux';
import {getEventDetails} from '../../event/redux/events.actions';

const HomeBuySellComp = ({
  _eventInfo,
  onBottomSheetClose,
  isShow,
  orderBookSelectedData,
  wsConnected,
  ws,
  isContestCard,
  liveStatsId,
}) => {
  const [apiRespnseUiData, setApiResponseUiData] = useState({
    isShow: false,
    orderData: null,
  });
  const [isShowCoinPromo, setIsShowCoinPromo] = useState(false);
  const dispatch = useDispatch();

  const onBottomSheetClose1 = (e, isApiSuccess) => {
    if (apiRespnseUiData?.isShow || isApiSuccess) {
      const isRouteHome = getCurrentRoute() || window?.location?.pathname;
      if (isRouteHome === 'Markets') {
        dispatch(getGamificationDetails());
      }
    }

    setApiResponseUiData({
      isShow: false,
      orderData: null,
    });
    onBottomSheetClose();
  };

  const onTradeClickReloadEventApi = useCallback(
    (orderStatus, showLiquidity = false) => {
      if (!orderStatus) {
        setApiResponseUiData({isShow: false, orderData: null});
        onBottomSheetClose1(null, true);
        return;
      }
      dispatch(getUser());
      setApiResponseUiData({
        isShow: true,
        orderData: orderStatus,
        showLiquidity: showLiquidity,
      });
      if (orderStatus?.respData?.show_promo_message) {
        setIsShowCoinPromo(true);
      }
      let orderTrack = orderStatus;
      if (orderStatus?.data) {
        orderTrack = orderTrack.data;
      }
      trackMoengageEvent('order status', {
        executed: orderTrack?.success
          ? orderTrack?.unmatched > 0
            ? 'partial'
            : 'success'
          : 'failed',
      });
    },
    [_eventInfo?.id],
  );

  useEffect(() => {
    if (
      wsConnected === 1 &&
      ws &&
      isShow &&
      _eventInfo?.is_price_editable &&
      liveStatsId !== _eventInfo?.id
    ) {
      try {
        ws.send(
          JSON.stringify({
            topic: isContestCard
              ? `fantasy-probe-detail_${_eventInfo?.id}`
              : `probe-detail_${_eventInfo?.id}`,
            action: 'subscribe',
          }),
        );
      } catch (e) {}
    }
    return () => {
      if (
        wsConnected === 1 &&
        ws &&
        isShow &&
        _eventInfo?.is_price_editable &&
        liveStatsId !== _eventInfo?.id
      ) {
        try {
          ws.send(
            JSON.stringify({
              topic: isContestCard
                ? `fantasy-probe-detail_${_eventInfo?.id}`
                : `probe-detail_${_eventInfo?.id}`,
              action: 'unsubscribe',
            }),
          );
        } catch (e) {}
      }
    };
  }, [isShow, wsConnected, ws]);

  const FormElement = useCallback(() => {
    return (
      <BuySell
        _eventInfo={_eventInfo}
        onTradeClickReloadEventApi={onTradeClickReloadEventApi}
        apiRespnseUiData={apiRespnseUiData}
        orderBookSelectedData={orderBookSelectedData}
        //onBottomSheetClose={onBottomSheetClose}
        //onBottomSheetOpen={onOpenBottomSheet}
        closeSheet={onBottomSheetClose}
      />
    );
  }, [_eventInfo, apiRespnseUiData, orderBookSelectedData]);
  return (
    <View>
      <CommonModal
        onModalCallBack={isShowCoinPromo ? () => {} : onBottomSheetClose1}
        customModalStyle={[
          globalStyle.modalView,
          isShowCoinPromo ? {paddingTop: 0} : {},
        ]}
        showModal={isShow ? true : false}
        persistent={isShowCoinPromo}>
        {isShow && <View>{FormElement()}</View>}
      </CommonModal>
    </View>
  );
};

const mapStateToProps = store => ({
  wsConnected: store?.liveReducer?.connected,
  ws: store?.liveReducer?.wsRef,
  //appIdle: store?.utilCommonData?.appIdle,
});

export default connect(mapStateToProps, null)(HomeBuySellComp);
